
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateCalculationTemplateFromCalculationDtoFormGroup() {
return new FormGroup({
    calculationId: new FormControl<number | undefined>(undefined, [Validators.required]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    calculationTemplateToReplaceId: new FormControl<number | undefined>(undefined),
})
;
}
      